import React from "react";
import { connect } from "react-redux";
import moment from "moment";


import './style.css';
import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import {

	Button,
	Modal,

	message,
	DatePicker,
	Icon,
	Divider,
	Form,
	Input,

	Radio,


	Calendar
} from 'antd';
import { fetchCompanyCalendarList } from "../../actions/attendance-actions";
import companyCalendarService from "../../services/Attendance/company-calendar-service";


const colorMap = ["#e69941", "#5bc8ec", "#1fbba6", "#f75556"];

class CompanyCalendar extends React.Component {

	state = {
		currentModalStatus: false
	}

	closeCurrentModal = () => {
		this.setState({currentModalStatus: false});
	}

	componentWillMount() {
		let date = {
			calendar_date: moment().format('YYYY-MM')
		}
		this.setState(date);
		this.props.fetchCompanyCalendarList(date);
	}

	dateCellRender = moment => {
		let result;
		this.props.attendance.companyCalendar.data.forEach(data => {
			if (data.calendar_date === moment.format("YYYY-MM-DD")) {
				result = <div style={{height:"100%", backgroundColor:colorMap[data.calendar_type], color: "white"}}>
						<h4 style={{backgroundColor:colorMap[data.calendar_type],margin:"0px",color:"white",padding: "4px 6px 0px",textAlign:"center"}}>{data.title}</h4>
						<p style={{backgroundColor:colorMap[data.calendar_type],margin:"0px",padding: "4px 6px 0px"}}>{data.content}</p>
					</div>;
			}
		});
		return result;
	}

	selectDate = momentObj => {
		if (!this.props.access.companyCalendar.u_value) {
			return;
		}
		let currentIndex, currentData = {
			calendar_date: momentObj.format("YYYY-MM-DD"),
			calendar_type: 0,
			content: null,
			title: null
		};
		this.props.attendance.companyCalendar.data.forEach((data, index) => {
			if (data.calendar_date === momentObj.format("YYYY-MM-DD")) {
				currentData = data;
				currentIndex = index;
			}
		})
		this.setState({
			currentModalStatus: true,
			currentData: currentData,
			currentIndex: currentIndex
		}, () => {
			console.log(this.state);
			// if (momentObj.format("YYYY-MM") !== moment().format('YYYY-MM')) {
			let date = {
				calendar_date: momentObj.format("YYYY-MM")
			}
			this.setState(date);
			this.props.fetchCompanyCalendarList(date);
			// }
		});
	}

	onPanelChange = moment => {
		let date = {
			calendar_date: moment.format('YYYY-MM')
		}
		this.setState(date);		
		this.props.fetchCompanyCalendarList(date);
	}

	submitCurrentModal = () => {
		this.props.form.validateFields((err, values) => {
			if (!err) {
				if (undefined !== this.state.currentIndex) {
					let puts = {
						...this.state.currentData,
						...values,
						calendar_date: values.calendar_date.format("YYYY-MM-DD"),
						calendar_date_2: values.calendar_date_2? values.calendar_date_2.format("YYYY-MM-DD"):""
					}

					companyCalendarService.updateCompanyCalendar(puts, res => {
						if (res.data.Success) {
							this.props.fetchCompanyCalendarList({calendar_date: this.state.calendar_date});
							this.closeCurrentModal();
							message.success("修改行事历成功", 4);
							
							if(res.data.Errors || res.data.Errors.length>0){
								res.data.Errors.forEach(function(item){
									message.error(item.Message)
								})

							}
							// this.props.fetchCompanyCalendarList(this.state.date);
							
						}else{
							message.error("修改行事历失败" + res.data.Errors[0], 4);
						}
					}
					// , err => {
					// 	message.error("修改行事历失败", 4);
					// }
					)

				}else{
					let posts = {
						...this.state.currentData,
						...values,
						calendar_date: values.calendar_date.format("YYYY-MM-DD"),
						calendar_date_2: values.calendar_date_2? values.calendar_date_2.format("YYYY-MM-DD"):""
					}
					companyCalendarService.insertCompanyCalendar(posts, res => {
						if (res.data.Success) {
							this.props.fetchCompanyCalendarList({calendar_date: this.state.calendar_date});
							this.closeCurrentModal();
							message.success("添加行事历成功", 4);
							// this.props.fetchCompanyCalendarList(this.state.date);
							if(res.data.Errors || res.data.Errors.length>0){
								res.data.Errors.forEach(function(item){
									message.error(item.Message)
								})

							}
							
						}else{
							message.error("添加行事历失败" + res.data.Errors[0], 4);
						}
					}
					// , err => {
					// 	message.error("添加行事历失败", 4);
					// }
					)
				}
			}
		})
	}

	exportCompanyCalendar = () => {
  	let ref = Modal.info({content: "正在准备需要下载的文件, 下载文件可能被浏览器阻挡, 请注意！"});	
		companyCalendarService.exportCompanyCalendar({}, res => {
			ref.destroy();
			if (res.data.Success) {
				window.open(res.data.Message);

			}else{
				message.error('下载失败', 4);
			}
		}, err => {
			ref.destroy();
			message.error('下载失败', 4);
		});
	}


	importCompanyCalendar = () => {
		this.setState({importModal: true});
	}

	closeImportModal = () => {
		this.setState({importModal: false});
	}

	downloadTemplate = () => {
  	let ref = Modal.info({content: "正在准备需要下载的文件, 下载文件可能被浏览器阻挡, 请注意！"});	
		companyCalendarService.downloadCompanyCalendarTemplate({}, res => {
			ref.destroy();
			if (res.data.Success) {
				window.open(res.data.Message);
			}else{
				message.error('下载失败', 4);
			}
		}, err => {
			ref.destroy();
			message.error('下载失败', 4);
		});
	}

	setUploadedFile = event => {
		this.setState({uploadedFile: event.target.files[0]});
	}

	uploadFile = () => {
		if (this.state.uploadedFile) {
			let ref = Modal.info({content: "正在导入文件, 请稍后..."});
			let formData = new FormData();
			formData.append("uploadedFile", this.state.uploadedFile);
			companyCalendarService.importCompanyCalendar(formData, res => {
				ref.destroy();
				if(res.data.Success) {
					message.success('导入文件成功', 4);
					this.setState({importModal: false});
					let date = {
						calendar_date: moment().format('YYYY-MM')
					}
					this.props.fetchCompanyCalendarList(date);
					if(res.data.Object){
		                window.open(res.data.Object);
		            }
				}else{
					message.error("导入文件失败, " + res.data.Errors[0], 4)
				}
			},err => message.error("导入文件失败", 4));	
		}else{
			message.error("请选择需要导入的文件", 4);
		}
	}

	render() {
		return (
			<div className="app-module-item">
				<div className="colAction">
					{this.props.access.companyCalendar.import_value && <Button type="primary" onClick={this.importCompanyCalendar}>
						<Icon type="cloud-upload-o" />
						<span>导入</span>
					</Button>}
					<Divider type="vertical" />
					{this.props.access.companyCalendar.export_value && <Button type="primary" onClick={this.exportCompanyCalendar}>
						<Icon type="cloud-download-o" />
						<span>导出</span>
					</Button>}
				</div>
				<Modal width="800px"
					visible={this.state.importModal}
					title="导入考勤模版"
					destroyOnClose={true}
					onCancel={this.closeImportModal}
					footer={<Button type="back" onClick={this.closeImportModal}>关闭</Button>}>
					<div style={{textAlign:"center",margin:"20px 0px 20px"}}>
						<div>
							<Button type="primary" onClick={this.downloadTemplate}>
								<Icon type="cloud-download-o" />
								<span>下载模板</span>
							</Button>
						</div>
						<div style={{marginTop:"40px"}}>
							<div>导入文件</div>
							<Input type="file" style={{height:"38px"}} onChange={this.setUploadedFile} />
							<Button type="primary" style={{marginTop:"20px"}} onClick={this.uploadFile}>
								<Icon type="cloud-upload-o" />
								<span>开始导入</span>
							</Button>
						</div>
					</div>
				</Modal>
				<Modal width="800px"
					visible={this.state.currentModalStatus}
					title="公司行事历"
					destroyOnClose={true}
					onCancel={this.closeCurrentModal}
					onOk={this.submitCurrentModal} >
					{ this.state.currentData &&
					<Form onSubmit={this.submitCurrentModal} layout="inline" style={{textAlign:"center"}}>
						<div>
							<Form.Item label="标题">
								{this.props.form.getFieldDecorator('title', {
									rules: [{ required: true, message: '请输入标题' }],
									initialValue: this.state.currentData.title
								})(<Input style={{width:"300px"}} />)}
							</Form.Item>
						</div>
						<div>
							<Form.Item label="开始日期">
								{this.props.form.getFieldDecorator('calendar_date', {
									rules: [{ required: false, message: '' }],
									initialValue: this.state.currentData.calendar_date ?
											moment(this.state.currentData.calendar_date, 'YYYY-MM-DD'): null
								})(<DatePicker style={{width:"300px"}} />)}
							</Form.Item>
						</div>
						<div>
							<Form.Item label="结束日期">
								{this.props.form.getFieldDecorator('calendar_date_2', {
									rules: [{ required: false, message: '' }],
									initialValue: this.state.currentData.calendar_date_2 ?
											moment(this.state.currentData.calendar_date_2, 'YYYY-MM-DD'): null
								})(<DatePicker style={{width:"300px"}} />)}
							</Form.Item>
						</div>
						<div>
							<Form.Item label="内容">
								{this.props.form.getFieldDecorator('content', {
									rules: [{ required: true, message: '请输入内容' }],
									initialValue: this.state.currentData.content
								})(<Input.TextArea rows={5} style={{width:"300px"}} />)}
							</Form.Item>
						</div>
						<div>
							<Form.Item label="类型">
								{this.props.form.getFieldDecorator('calendar_type', {
									rules: [{ required: true, message: '请输入内容' }],
									initialValue: this.state.currentData.calendar_type
								})(
								<Radio.Group style={{width:"300px",textAlign:"left"}}>
									<Radio.Button value={0} style={{color:colorMap[0]}}>默认</Radio.Button>
									<Radio.Button value={1} style={{color:colorMap[1]}}>假期</Radio.Button>
									<Radio.Button value={2} style={{color:colorMap[2]}}>法定日</Radio.Button>
									<Radio.Button value={3} style={{color:colorMap[3]}}>活动</Radio.Button>
								</Radio.Group>)}
							</Form.Item>
						</div>
					</Form>}
				</Modal>
			{ this.props.attendance.companyCalendar.dataStatus === "loaded" &&
				<Calendar dateCellRender={this.dateCellRender}
					onSelect={this.selectDate}
					onPanelChange={this.onPanelChange} />
			}
			</div>
		)
	}
}
const mapStateToProps = state => {
	return {
		attendance: state.attendance,
	}
}
const mapDispatchToProps = {
	fetchCompanyCalendarList
}

CompanyCalendar = Form.create()(CompanyCalendar);

export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(CompanyCalendar));








// WEBPACK FOOTER //
// ./src/routes/Attendance/CompanyCalendar.js